
import * as api from './api';
import { CrudApiService, CrudServiceProps } from "../ApiCrudService";

export const ScheduledTaskDefCrudService = function(props: 
  CrudServiceProps<api.ScheduledTaskDef,string>
) {
  
  return CrudApiService<api.ScheduledTaskDef,string>({...props, api: api, entityName: 'ScheduledTaskDef'});

};